import React from 'react';
import { Route, Routes } from 'react-router-dom';
import RoleList from './RoleList';
import RoleForm from './RoleForm';

const RoleRoutes = () => {
  return (
    <Routes>
      <Route index element={<RoleList />} />
      <Route path="new" element={<RoleForm />} />
      <Route path="edit/:id" element={<RoleForm />} />
    </Routes>
  );
};

export default RoleRoutes; 